import { graphql } from 'gatsby';
import useLinkProps from '@/components/Link/hooks/useLinkProps';

import { StyledEventsLink, StyledText, StyledType, StyledLocation } from './EventLink.styles';

const EventLink = ({ system, elements }: Queries.EVENT_LINKFragment) => {
  const {
    type,
    link: {
      value: { linkElements },
    },
    location,
  } = elements;
  const hasLocation = !!location?.value;

  const { linkChildren, linkProps } = useLinkProps({
    action: linkElements.action.value,
    target: linkElements.target?.value,
    event: linkElements.event?.value,
  });
  const linkText = linkElements.text.value;

  return (
    <StyledEventsLink data-codename={system.codename} {...linkProps}>
      <StyledType>{type.value}</StyledType>
      <StyledText>{linkText}</StyledText>
      {hasLocation && <StyledLocation>{location.value}</StyledLocation>}
      {linkChildren}
    </StyledEventsLink>
  );
};

export default EventLink;

export const fragment = graphql`
  fragment EVENT_LINK on kontent_item_event_link {
    system {
      id
      codename
    }
    elements {
      type {
        value
      }
      link {
        value {
          ...LINK
        }
      }
      location {
        value
      }
    }
  }
`;
